import { render, staticRenderFns } from "./CustomerListComponent.vue?vue&type=template&id=100ac18a"
import script from "./CustomerListComponent.vue?vue&type=script&lang=js"
export * from "./CustomerListComponent.vue?vue&type=script&lang=js"
import style0 from "./CustomerListComponent.vue?vue&type=style&index=0&id=100ac18a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports